import { render, staticRenderFns } from "./MoreAbout.vue?vue&type=template&id=0a409f32&scoped=true&"
import script from "./MoreAbout.vue?vue&type=script&lang=js&"
export * from "./MoreAbout.vue?vue&type=script&lang=js&"
import style0 from "./MoreAbout.vue?vue&type=style&index=0&id=0a409f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a409f32",
  null
  
)

export default component.exports